/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *\

  Time functions

  Author Alex Lowe

\* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */

const shortMonthNames = ["Jan.","Feb.","Mar.","Apr.","May.","Jun.","Jul.","Aug.","Sept.","Oct.","Nov.","Dec."]
const longMonthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
//2021-12-10 20:02:04
//Dec. 10, 2021
export const getNiceString = (dateString, longMonth) => {
  if(!dateString) {
    return ""
  }

  const s = dateString.split(" ")
  const yyyymmdd = s[0];
  const c = yyyymmdd.split("-")

  if(c.length != 3) {
    return ""
  }
  
  const y = c[0]
  const m_ = parseInt(c[1])-1

  if(isNaN(m_)) {
    return ""
  }

  const m = longMonth ? longMonthNames[m_] : shortMonthNames[m_]
  const d = parseInt(c[2])

  return `${m} ${d}, ${y}`
  
}